var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sessionStorageSet)?_c('div',{staticClass:"dealer"},[_c('span',{staticClass:"back"},[_vm._v("‹")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.url_redirect_to_dealer}},[_vm._v(_vm._s(_vm.label_back_to)+" "+_vm._s(_vm.label_company_name))]),_vm._v(" "),_c('img',{attrs:{"height":"45","src":_vm.logo_src,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }